/** Takes a prop name and returns a function which plucks that prop from a props object.
 *
 * Useful inside a styled-components declaration.
 */
export const prop = <T, Key extends keyof T>(key: Key) => (props: T) => props[key];
